<template>
  <div id="about" class="position-relative">
    <div class="page-inner-wrapper position-relative white-bg">
      <div class="position-relative page-header bg-img-atr-fix ">
        <div class="position-absolute overlay overlay-bg-lightdark">
          <div class="d-flex flex-row align-items-center justify-content-center">
            <h1 class="white-color" v-scrollanimation>{{dataText.moduleHeaders[0]}}</h1>
          </div>
        </div>
      </div>
      <div class="intro-text-container-sm p-text blue-bg text-center">
        <p class="white-color left" style="margin: 0;" v-scrollanimation>{{dataText.p1}}</p>
      </div>
      <div class="container-fluid">
        <div class="col-sm-12 module-space text-module">
          <div class="column-inner">
            <div class="wrapper">
              <div class="module-text-container p-text text-justify">
                <p v-scrollanimation>{{dataText.p2}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="chess-table">
            <div class="d-table-cell a-bg-1 bg-img-atr left" v-scrollanimation></div>
            <div class="d-table-cell chess-table-textbox p-text textbox-right text-justify right" v-scrollanimation>
              <p class="pre-formatted">{{dataText.t1}}</p>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="chess-table">
            <div class="d-table-cell chess-table-textbox textbox-left p-text text-justify left" v-scrollanimation>
              <p class="pre-formatted">{{dataText.t2}}</p>
            </div>
            <div class="d-table-cell a-bg-2 bg-img-atr right" v-scrollanimation></div>
          </div>
        </div>
        <div class="col-sm-12 module-space text-module">
          <div class="column-inner">
            <div class="wrapper">
              <div class="module-text-container p-text text-center">
                <p v-scrollanimation>{{dataText.p3}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 row-block blue-bg">
        <div class="column-inner h-align">
          <div class="wrapper">
            <div class="container">
              <div v-scrollanimation class="col-md-4 col-display">
                <div class="column-inner">
                  <div class="wrapper">
                    <div class="counter-wrapper">
                      <div class="counter-header">
                        <div class="counter-inner text-center">
                          <h4 class="white-color">12</h4>
                        </div>
                      </div>
                      <div class="p-text counter-text text-center">
                        <p class="white-color nowrap-formatted">{{dataText.counter[0]}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-scrollanimation class="col-md-4 col-display">
                <div class="column-inner">
                  <div class="wrapper">
                    <div class="counter-wrapper">
                      <div class="counter-header">
                        <div class="counter-inner text-center">
                          <h4 class="white-color">188,352</h4>
                        </div>
                      </div>
                      <div class="p-text counter-text text-center">
                        <p class="white-color nowrap-formatted">{{dataText.counter[1]}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-scrollanimation class="col-md-4 col-display">
                <div class="column-inner">
                  <div class="wrapper">
                    <div class="counter-wrapper">
                      <div class="counter-header">
                        <div class="counter-inner text-center">
                          <h4 class="white-color">3,596</h4>
                        </div>
                      </div>
                      <div class="p-text counter-text text-center">
                        <p class="white-color nowrap-formatted">{{dataText.counter[2]}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-lg-12 module-space">
          <div class="column-inner">
            <div class="wrapper">
              <div class="module-header text-center">
                <h1>{{dataText.moduleHeaders[1]}}</h1>
              </div>
              <div class="spacer-md"></div>
              <div class="content-wrapper">
                <div class="card-columns">
                  <div v-scrollanimation class="card" v-for="employee in staff" :key="employee.id">
                    <img class="card-img-top" :src="employee.img" :alt="employee.name">
                    <div class="card-info-overlay trans-500-ms">
                      <div class="team-contact text-center trans-500-ms">
                        <a class="trans-300-ms" :href="employee.mail"><span class="mail-icon-bg bg-img-atr"></span></a>
                      </div>
                      <div class="team-content text-center trans-500-ms">
                        <h5 class="black-color">{{employee.name}}</h5>
                        <h6>{{employee.position}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="project-module" class="container-fluid gray-bg">
        <div class="col-lg-12 module-space">
          <div class="column-inner">
            <div class="wrapper">
              <div class="module-header text-center">
                <h1>{{dataText.moduleHeaders[2]}}</h1>
              </div>
              <div class="spacer-md"></div>
              <div id="project-cards" class="content-wrapper">
                <div class="card-columns">
                  <div v-scrollanimation class="card" v-for="project in projects" :key="project.id">
                    <div class="card-img-top bg-img-atr" :style="{backgroundImage: 'url(' + project.img + ')'}"></div>
                    <div class="card-info-overlay trans-500-ms" :style="{backgroundColor: project.color}">
                      <div class="team-contact trans-500-ms">
                        <router-link :to="{name: 'ProjectInfo', params: {id: project.id, project: project}}"><span class="white-color" style="font-size: 75px;">&rarr;</span></router-link>
                      </div>
                      <div class="team-content text-left trans-500-ms position-absolute" style="bottom: 20px; left: 20px;">
                        <router-link :to="{name: 'ProjectInfo', params: {id: project.id, project: project}}"><h5 class="white-color">{{project.title}}</h5></router-link>
                        <ul>
                          <li v-for="(s, index) in project.service" :key="index" class="white-color">{{s}}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-lg-12 module-space">
          <div class="column-inner">
            <div class="wrapper d-flex form-direction">
              <div class="col-md-6 col-display left" v-scrollanimation>
                <div class="column-inner">
                  <div class="wrapper">
                    <div class="module-header">
                      <h3>{{dataText.moduleHeaders[3]}}</h3>
                    </div>
                    <div class="spacer-sm"></div>
                    <form class="query-form">
                      <label for="fullName">{{dataText.questionForm[0]}}</label>
                      <input id="fullName" class="block" type="text" v-model="form.fullName" required>
                      <label for="email">{{dataText.questionForm[1]}}</label>
                      <input id="email" class="block" type="email" v-model="form.email" required>
                      <label for="select">{{dataText.questionForm[2]}}</label>
                      <input id="select" style="display: none;">
                      <b-form-select id="select" class="select" v-model="form.service" :options="formSelectOptions" style="width: 280px;"></b-form-select>
                      <label for="message">{{dataText.questionForm[3]}}</label>
                      <textarea id="message" class="block" rows="5" cols="50" v-model="form.message" required></textarea>
                      <div class="form-btn-container">
                        <transition name="fadeInRight" mode="out-in">
                          <div v-if="successSubmit" :key="1" class="info-submit blue-bg">
                            <p>Your Inquiry was Successfully Submitted!</p>
                          </div>
                          <div v-if="warningSubmit" :key="2" class="info-submit bg-warning">
                            <p>All fields are required, so make sure you type everything right and di not skip some!</p>
                          </div>
                          <div v-if="dangerSubmit" :key="3" class="info-submit bg-danger">
                            <p>Something went wrong. Please refresh the page and try again!</p>
                          </div>
                        </transition>
                      </div>
                    </form>
                    <div class="form-btn-container">
                      <button @click="submitForm" class="form-btn">SEND</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-display right" v-scrollanimation>
                <div class="column-inner">
                  <div class="wrapper">
                    <table class="firm-info-table">
                      <tr>
                        <th colspan="2" class="h3-table-header"><h3>{{dataText.firmInfo.name}}</h3></th>
                      </tr>
                      <tr>
                        <td>PDV ID:</td>
                        <td>{{dataText.firmInfo.pdv}}</td>
                      </tr>
                      <tr>
                        <td>MBS:</td>
                        <td>{{dataText.firmInfo.mbs}}</td>
                      </tr>
                      <tr>
                        <td>OIB:</td>
                        <td>{{dataText.firmInfo.oib}}</td>
                      </tr>
                      <tr>
                        <th>{{dataText.firmInfo.contact.title}}</th>
                      </tr>
                      <tr>
                        <td>{{dataText.firmInfo.contact.a}}</td>
                        <td>{{dataText.firmInfo.contact.address}}</td>
                      </tr>
                      <tr>
                        <td>{{dataText.firmInfo.contact.e}}</td>
                        <td>{{dataText.firmInfo.contact.email}}</td>
                      </tr>
                      <tr>
                        <td>{{dataText.firmInfo.contact.t}}</td>
                        <td>{{dataText.firmInfo.contact.tel}}</td>
                      </tr>
                      <tr>
                        <th>{{dataText.firmInfo.bank.title}}</th>
                      </tr>
                      <tr>
                        <td colspan="2">{{dataText.firmInfo.bank.bankName}}</td>
                      </tr>
                      <tr>
                        <td colspan="2">{{dataText.firmInfo.bank.bankAdress}}</td>
                      </tr>
                      <tr>
                        <td>IBAN:</td>
                        <td>{{dataText.firmInfo.bank.iban}}</td>
                      </tr>
                      <tr>
                        <td>SWIFT:</td>
                        <td>{{dataText.firmInfo.bank.swift}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 module-space">
          <div class="column-inner">
            <div class="wrapper">
              <div class="maps-container">
                <iframe v-scrollanimation width="600" height="350" frameborder="0" style="border:0"
                        src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ-5wCFsTTfEcRhS_yqr-U9gg&key=..." allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from "../components/Footer";

  export default {
    name: 'Home',
    props: {
      webData: {
        type: Object,
        required: true
      }
    },
    components: {
      Footer
    },
    data () {
      return {
        dataText: this.webData.aboutUs,
        staff: [
          {id: 1, name: 'Hrvoje Miter', position: this.webData.aboutUs.staff[0], mail: 'mailto:hrvoje.miter@h3.solutions', img: this.$store.state.imgHM},
          {id: 2, name: 'Hrvoje Rubeša', position: this.webData.aboutUs.staff[1], mail: 'mailto:hrvoje.rubesa@h3.solutions', img: this.$store.state.imgHR},
          {id: 3, name: 'Hrvoje Žubrinić', position: this.webData.aboutUs.staff[2], mail: 'mailto:hrvoje.zubrinic@h3.solutions', img: this.$store.state.imgHZ},
          {id: 4, name: 'Toni Dumančić', position: this.webData.aboutUs.staff[3], mail: 'mailto:toni.dumancic@h3.solutions', img: this.$store.state.imgTD},
          {id: 5, name: 'Nikola Semjaniv', position: this.webData.aboutUs.staff[4], mail: 'mailto:nikola.semjaniv@h3.solutions', img: this.$store.state.imgNS}
        ],
        projects: this.webData.aboutUs.projects.items,
        form: {
          fullName: '',
          email: '',
          service: '',
          message: ''
        },
        formSelectOptions: this.webData.aboutUs.questionForm[4],
        successSubmit: false,
        warningSubmit: false,
        dangerSubmit: false
      }
    },
    methods: {
      submitForm () {

      }
    }
  }
</script>

<style>
  #about, #blog, #services, #marketing {
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .page-inner-wrapper {
    margin-bottom: 330px;
    z-index: 2;
  }
  #about .page-header .overlay .d-flex {
    height: 100%;
  }
  .intro-text-container-sm {
    padding: 10px 20px;
  }
  .intro-text-container-sm.p-text p {
    font-size: 15px;
  }
  .module-text-container {
    padding: 25px 0;
  }
  .maps-container {
    width: 100%;
    height: 380px;
  }
  .query-form label, .query-form input, .query-form .select, .query-form textarea {
    display: block;
  }
  .firm-info-table tr .h3-table-header {
    vertical-align: top;
  }
  .firm-info-table tr th {
    height: 80px;
    vertical-align: middle;
  }
  .h-align {
    width: auto;
    margin: 0 auto;
  }
  /*********************/
  /*    BACKGROUND    */
  #about .page-inner-wrapper .page-header {
    background-image: url("../assets/photos/h3_about_us_bg.jpg");
  }
  .a-bg-1 {
    background-image: url("../assets/photos/chess_img_01.jpg");
    height: 580px;
  }
  .a-bg-2 {
    background-image: url("../assets/photos/chess_img_02.jpg");
    height: 580px;
  }
  /********************/
  /*     ELEMENTS    */
  .module-space {
    padding: 60px 0;
  }

  /********************/
  /*     COUNTER     */
  .counter-wrapper {
    padding: 60px 0 44px;
  }
  .counter-header .counter-inner h4 {
    font-size: 30px;
    letter-spacing: 1px;
    font-weight: bold;
  }

  /********************/
  /*       CARD      */

  .content-wrapper .card-columns .card {
    overflow: hidden;
    display: inline-block;
  }
  .card-info-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    height: 100%;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, .685);
    opacity: 0;
  }
  .team-contact {
    transform: translateY(-20px);
    opacity: 0;
  }
  .team-content {
    transform: translateY(20px);
    opacity: 0;
  }
  .card-info-overlay .team-content h5 {
    font-weight: bold;
    margin-bottom: 0;
  }
  .card-info-overlay .team-content h6 {
    color: #0C0C0C;
  }
  .card:hover .card-info-overlay {
    opacity: 1;
  }
  .card:hover .card-info-overlay .team-contact, .card:hover .card-info-overlay .team-content {
    transform: translateY(0);
    opacity: 1;
  }
  .card-info-overlay .team-contact a {
    width: 32px;
    height: 32px;
    display: block;
    margin-bottom: 30px;
  }
  .card-info-overlay .team-contact a:hover .mail-icon-bg {
    background-image: url("../assets/icons/email_color.png");
  }
  .mail-icon-bg {
    display: block;
    width: inherit;
    height: inherit;
    background-image: url("../assets/icons/email_black.png");
  }
  /***************************/
  /*         BUTTONS        */
  .form-btn-container {
    padding: 15px 0;
  }
  .form-btn {
    width: 180px;
    padding: 12px 50px;
    border: 2px solid #cecece;
    text-transform: uppercase;
    color: #cecece;
    background: transparent;
    font-size: 16px;
    font-weight: bold;
  }
  .form-btn:hover {
    color: #0C0C0C;
    border: 2px solid #0C0C0C;
  }

  /***************************/
  /*     INPUT ELEMENTS     */
  label, input, textarea, .form-btn {
    -webkit-transition: all 500ms;
    -moz-transition: all 500ms;
    -ms-transition: all 500ms;
    -o-transition: all 500ms;
    transition: all 500ms;
  }
  textarea {
    padding-top: 3px;
    border: 1px solid transparent;
    border-bottom-color: #cecece;
  }
  input, textarea {
    padding-left: 3px;
  }
  input, #select {
    height: 40px;
    width: 370px;
    margin-bottom: 5px !important;
    border: 1px solid transparent;
    border-bottom-color: #cecece;
  }
  input:active, #select:active, textarea:active {
    border: none;
    border-bottom: 1px solid #2c3e50;
  }
  input:focus, #select:focus, textarea:focus {
    outline: none;
    outline-offset: 0;
    border: none;
    border-bottom: 1px solid #2c3e50;
    box-shadow: none;
  }
  /******************************************/
  /*            ANIMATION                  */
  /****************************************/
  .before-enter-right {
    opacity: 0;
    transform: translateX(250px);
    transition: all 500ms ease-out;
  }
  .before-enter-left {
    opacity: 0;
    transform: translateX(-250px);
    transition: all 500ms ease-out;
  }
  .enter {
    opacity: 1;
    transform: translateX(0px);
    transition-delay: 500ms;
  }
</style>